export default "__VITE_ASSET__D3$ECMbb__"